exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".groupAuthorizerTag[data-v-105ddb3d]{padding:3px 5px;margin-right:5px;color:#5834b4;font-size:.85em;background-color:#f4f2f8;border:1px solid #e2dced;border-radius:2px}", ""]);

// exports
